import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Invoice, InvoiceMeta } from 'dashboard/models/invoice';
import { setCurrentInvoice } from 'dashboard/redux/actions/current-invoice';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadCurrentInvoice = () => {
  return async (dispatch: Dispatch) => {
    const { data, meta } = await SessionClientDashboard.getResource<Invoice, InvoiceMeta>(
      ApiEndpoint.Invoice,
      'current',
    );

    if (meta) {
      dispatch(setCurrentInvoice(data, meta.commitments));
    } else {
      dispatch(setCurrentInvoice(data, []));
    }
  };
};
